import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Image } from '@core/components/Image';
import { CustomProductNameStyle } from '@core/shopping/components/CustomFonts';
import { CARD_BORDER_RADIUS, CARD_CTA_HEIGHT, CARD_GAP, CARD_HEIGHT, CARD_MAX_WIDTH, CARD_PADDING, CARD_PADDING_COMPACT, } from './ProductCardCarousel.styles';
const EllipsisText = css `
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;
export const ProductCardWrapper = styled.a `
  background: var(--background, rgb(64 64 64));
  border-radius: var(
    --border-radius,
    ${({ borderStyle }) => (borderStyle === 'hard' ? 0 : CARD_BORDER_RADIUS)}px
  );
  box-shadow: var(--box-shadow-subtle);
  display: flex;
  flex-direction: column;
  margin: ${CARD_GAP}px 0;
  overflow: hidden;
  position: relative;
  text-decoration: none !important;
  transition: var(--transition-all-medium);

  ${({ showCTA }) => showCTA
    ? css `
          height: calc(${CARD_HEIGHT}px + ${CARD_CTA_HEIGHT}px);
        `
    : css `
          height: ${CARD_HEIGHT}px;
        `}
  ${(props) => props.cardSize &&
    css `
      width: ${props.cardSize}px;
    `}
  min-width: ${CARD_HEIGHT}px;
  max-width: ${CARD_MAX_WIDTH}px;

  &:hover {
    box-shadow: var(--box-shadow);
  }
`;
export const ProductCardInnerWrapper = styled.div `
  display: flex;
  flex: 0 0 ${CARD_HEIGHT}px;
  height: ${CARD_HEIGHT}px;
  justify-content: flex-start;
  padding: ${({ compactSize }) => compactSize ? CARD_PADDING_COMPACT : CARD_PADDING}px;
  width: 100%;
`;
export const ProductCardInfoWrapper = styled.div `
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  font-style: normal;
  font-weight: 500;
  height: 100%;
  justify-content: space-between;
  padding-inline-end: 0;
  padding-inline-start: 10px;
  ${EllipsisText}
`;
export const ProductImage = styled(Image, {
    shouldForwardProp: (propName) => !['compactSize', 'borderStyle'].includes(propName),
}) `
  aspect-ratio: 1 / 1;
  border-radius: max(
    ${({ borderStyle }) => (borderStyle === 'hard' ? '0' : '4px')},
    calc(
      var(
          --border-radius,
          ${({ borderStyle }) => borderStyle === 'hard' ? '0' : CARD_BORDER_RADIUS}px
        ) -
        ${({ compactSize }) => compactSize ? CARD_PADDING_COMPACT : CARD_PADDING}px
    )
  );
  display: block;
  height: 100%;
  object-fit: cover;
  width: auto;
`;
export const LabelWrapper = styled.span `
  font-size: 13px;
  line-height: 18px;
  margin-bottom: 3px;
  width: 100%;
  ${EllipsisText}
  ${CustomProductNameStyle}
`;
export const ProductUnitName = styled.span `
  font-size: 10px;
  font-weight: 500;
  line-height: 14px;
  margin-bottom: 2px;
  width: 100%;
  ${EllipsisText}
  ${CustomProductNameStyle}
`;
export const PriceWrapper = styled.div `
  font-size: 13px;
  line-height: 18px;
  min-height: 18px;
  width: 100%;
`;
export const ProductCardCTA = styled.div `
  align-items: center;
  background: var(--primary-button-background);
  border: 0;
  color: var(--primary-button-color);
  display: flex;
  flex: 0 0 ${CARD_CTA_HEIGHT}px;
  font-size: 11px;
  height: ${CARD_CTA_HEIGHT}px;
  justify-content: center;
  line-height: 15px;
  width: 100%;
`;
export const ProductDetailWrapper = styled.div `
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
`;
export const ProductCardCTAText = styled.span `
  display: inline-block;
  font-weight: 600;
`;
